import { Table } from "@similarweb/pro-logic-components";

import { useTranslation } from "pro-features/components/WithTranslation";

import { CommonTableTop, CommonTableTopEmpty } from "../../../components/CommonTableTop";
import { STATIC_TABLE_PROPS } from "../../../constants";
import { useSearchFilter } from "../../../hooks/useSearchFilter";
import { useSelectedTrafficSource } from "../../../traffic-sources-tabs";
import { useShareOfChannelTrafficData } from "../../useShareOfChannelTrafficData";

import { useColumnsConfig, type Data } from "./useColumnsConfig";

export const ShareOfChannelTrafficCompetitorsTable = () => {
    const translate = useTranslation();
    const trafficSource = useSelectedTrafficSource();
    const { data, isLoading, excelRowCount } = useShareOfChannelTrafficData(trafficSource.value);
    const { data: filteredData, onSearchChange } = useSearchFilter(data);
    const columnsConfig = useColumnsConfig();
    const excelDownloadConfig = {
        url: "/api/benchmark/traffic-channels/share/by-channel/excel",
        rowCount: excelRowCount,
    };

    const title = translate("bt.report.channels.share-of-channel-traffic-competitors-table.title", {
        trafficName: translate(trafficSource.title),
    });
    const additionalTableProps = filteredData?.length
        ? {
              scroll: { y: 228 },
              style: { height: "290px", overflow: "hidden" },
          }
        : {};

    return (
        <Table<Data>
            {...STATIC_TABLE_PROPS}
            data={filteredData}
            columnConfig={columnsConfig}
            isLoading={isLoading}
            noData={{
                title: translate("global.nodata.notavilable"),
            }}
            {...additionalTableProps}
        >
            {data?.length ? (
                <CommonTableTop
                    excelDownload={excelDownloadConfig}
                    title={title}
                    onSearchChange={onSearchChange}
                />
            ) : (
                <CommonTableTopEmpty title={title} />
            )}
        </Table>
    );
};
